import { Injectable } from '@angular/core';
import { ToastService } from '@tylertech/forge-angular';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
/**
 * Creates an instance of SnackbarService.
 * @param {ToastService} snackBar Snackbar Toaster Service Object
 * @memberof SnackbarService
 */
constructor(private _toastService: ToastService) { }
/**
 * Displays Message to user though Snackbar
 *
 * @param {string} message string to display on toaster
 * @memberof SnackbarService
 */
showMessage(message: string): void {
    this._toastService.show({
        message: message,
        placement: 'bottom-end',
        duration: 3000
    });
}
}